/**
 * clients詳細ページ KVエリア
 */
export default class clientsKV {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'clientsKV';
    this.isStart = false;
    this.el = document.getElementById('l-projects-mv');

    if (this.el) {
      this.init();
    }
  }

  /**
   * 表示前
   */
  init() {

  }

  /**
   * 表示時
   */
  start() {
    if (this.el) {
      TweenMax.staggerFromTo(this.el.querySelectorAll('.l-projects-mv__col > .col-pic img'), 0.4, {
          opacity: 0,
        },{
          opacity: 1,
          ease: Quint.easeInOut,
        },
        0.05
      );
      TweenMax.staggerFromTo(this.el.querySelectorAll('.l-projects-mv__col > .col-pic img'), 1.0, {
          opacity: 0,
          scale: 1.3
        },{
          scale: 1,
          opacity: 1,
          ease: Quint.easeOut,
        },
        0.05,
        this.startComp.bind(this)
      );
    }
  }

  /**
   * 表示完了
   */
  startComp() {
    this.isStart = true;
  }
}
